export default __webpack_public_path__ + "static/media/thread.6e29c677.jpeg";